import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Scanner,
  IDetectedBarcode,
  useDevices,
} from "@yudiel/react-qr-scanner";
import { notification } from "../../utils/Notifications.tsx";
import moment from "moment";
import {
  registerAssistance,
  authorizeAssistance,
  validateSimplifiedQr,
} from "../../services/assistanceCheck.service.ts";
import { findConfigurationByKey } from "../../services/configuration.service.ts";
import {
  fetchPartner,
  getMessagePartner,
} from "../../services/partner.service.ts";
import { useSelector } from "react-redux";
import { RootState } from "../../store/index.ts";
import { clockBranchFromSession } from "./clockBranch.ts";
import { readClockPartner } from "./clockPartner.ts";
import { isValidForSweetAlert } from "../../validation/schemas/MessagePartnerSchema.ts";
import Swal from "sweetalert2";
import Branch from "../../models/Branch.ts";
import { useWebSocket } from "../../hooks/useWebSocket.tsx";
import Loader from "../../components/Loader.tsx";
import Webcam from "react-webcam";
import {
  fetchInfoCode,
  registerAssistanceCheckByCode,
} from "../../services/assistenceCode.ts";
import { useFormik } from "formik";
import * as Yup from "yup";
import CustomInput from "../../components/formik/CustomInput.tsx";
import ValidationSkeleton from "../../components/ValidationSkeleton.tsx";
//esto lo hice pero no se si te guste es un banner arriba del qr
import ScannerStatus from "../../components/ScannerStatus.tsx";
import UserRegistrationModal from "../../components/UserRegistrationModal.tsx";
import BranchConfirmationModal from "../../components/BranchConfirmationModal.tsx";
import MissingDocumentsModal, {
  MissingDocumentItem,
} from "../../components/reloj-checador/MissingDocumentsModal.tsx";

const INACTIVITY_TIMEOUT_MS = 10 * 60 * 1000; // 10 minutos
const HEALTH_REFRESH_MS = 5 * 60 * 1000;
const HEALTH_CHECK_INTERVAL_MS = 5 * 1000; // 5 segundos


const SCAN_COOLDOWN_MS = 2000;
const SAME_QR_COOLDOWN_MS = 3500;
const SCANNER_SCAN_DELAY_MS = 800;
const MAX_CONSECUTIVE_ERRORS = 3;

interface QrData {
  p?: number;
  t?: number;
  dataQr?: string;
  buildId?: string;
  userId?: string;
}

interface AssistanceResponse {
  status: string;
  message?: string;
  assistance?: {
    status: string;
    checkTime?: string;
    checkDate?: string;
  };
  type?: string;
  errorType?: string;
  documentsRequired?: {
    missing?: MissingDocumentItem[];
  } | MissingDocumentItem[];
}

interface Partner {
  id: number;
  person?: {
    firstName: string;
    lastName: string;
    secondLastName: string;
  };
  name?: string;
}

/** Estado del modal de documentos faltantes */
interface MissingDocsModalState {
  open: boolean;
  list: MissingDocumentItem[];
  onClose?: () => void;
}

// Modal de documentos faltantes se declara en un componente separado

const QrScanner = () => {
  const [scannerEnabled, setScannerEnabled] = useState(true);
  const [actualDate, setActualDate] = useState(new Date());
  const [branch, setBranch] = useState<Branch>();
  const [tempUser, setTempUser] = useState({
    nombre: "",
    checkAt: "",
    status: "",
  });
  const [deviceId, setDeviceId] = useState<string | undefined>(undefined);
  const [isValidating, setIsValidating] = useState(false);
  const [lastScanTime, setLastScanTime] = useState<string>("");
  const [showRegistrationModal, setShowRegistrationModal] = useState(false);
  const [showBranchConfirmation, setShowBranchConfirmation] = useState(true);
  const [isScannerPaused, setIsScannerPaused] = useState(false); // Libera cámara cuando tab está oculta
  const [cameraPausedByInactivity, setCameraPausedByInactivity] = useState(false); // Desactiva cámara tras 5s inactivo; botón para reactivar

  const lastScanTimestampRef = useRef<number>(Date.now());
  const lastRefreshTimestampRef = useRef<number>(Date.now());
  const isProcessingRef = useRef<boolean>(false); // Lock síncrono (evita race con state async)
  const lastProcessedQrRef = useRef<{
    rawValue: string;
    timestamp: number;
  } | null>(null);
  const consecutiveErrorsRef = useRef<number>(0);

  const devices = useDevices();
  const [refreshKey, setRefreshKey] = useState(0);
  const [show, setShow] = useState(true);
  const [loading, setloading] = useState(false);
  const { isConnected, triggerUpdate } = useWebSocket();
  const { user } = useSelector((state: RootState) => state.auth);
  const [configuration, setConfiguration] = useState<any>(null);
  const [modeCode, setModeCode] = useState(false);
  const [capturedImage, setCapturedImage] = useState<string | null>(null);
  const [checkCode, setCheckCode] = useState<string | null>(null);
  const webcamRef = React.useRef<Webcam>(null);
  const [facingMode, setFacingMode] = useState("user");
  const [inputCode, SetInputCode] = useState("");
  const [inputLastName, SetInputLastName] = useState("");
  const [messageWildcards, setMessageWildcards] = useState("");
  const [countdown, setCountdown] = useState<number | null>(null);
  const [isCountingDown, setIsCountingDown] = useState(false);
  const [missingDocsModal, setMissingDocsModal] = useState<MissingDocsModalState>({
    open: false,
    list: [],
  });
  const toggleFacingMode = () => {
    setFacingMode((prevMode) => (prevMode === "user" ? "environment" : "user"));
  };

  const refreshScanner = React.useCallback(() => {
    setRefreshKey((prev) => prev + 1);
    lastRefreshTimestampRef.current = Date.now();
    lastScanTimestampRef.current = Date.now();
  }, []);

  const activateCamera = React.useCallback(() => {
    setCameraPausedByInactivity(false);
    isProcessingRef.current = false;
    setScannerEnabled(true);
    setIsValidating(false);
    refreshScanner();
  }, [refreshScanner]);

  const handleBranchConfirmation = () => {
    setShowBranchConfirmation(false);
    setTempUser({
      nombre: "",
      checkAt: "",
      status: "",
    });
    setShowRegistrationModal(false);
  };

  /**
   * Formulario para el registro de asistencia por código
   * @param values - Valores del formulario
   * @param values.code - Código de asistencia
   * @param values.lastName - Primer apellido del partner
   * @returns Respuesta del backend
   * @throws Error si no se pudo acceder a la cámara
   */
  const formik = useFormik({
    initialValues: {
      code: "",
      lastName: "",
    },
    validationSchema: Yup.object({
      code: Yup.string().required("El código es requerido"),
      lastName: Yup.string().required("El primer apellido es requerido"),
    }),
    onSubmit: async (values) => {
      setloading(true);
      if (!webcamRef.current) {
        setloading(false);
        notification("error", "No se pudo acceder a la cámara", "danger");
        return;
      }

      try {
        await new Promise<void>((resolve) => {
          let current = 3;
          setCountdown(current);
          setIsCountingDown(true);

          const interval = setInterval(() => {
            current -= 1;

            if (current <= 0) {
              clearInterval(interval);
              setCountdown(null);
              setIsCountingDown(false);
              resolve();
              return;
            }

            setCountdown(current);
          }, 1000);
        });

        const capturedImage = webcamRef.current.getScreenshot();
        if (!capturedImage) {
          setloading(false);
          notification("error", "Error al capturar la imagen", "danger");
          return;
        }

        const base64ToBlob = (base64: string, mimeType: string) => {
          const byteString = atob(base64.split(",")[1]);
          const arrayBuffer = new ArrayBuffer(byteString.length);
          const uintArray = new Uint8Array(arrayBuffer);
          for (let i = 0; i < byteString.length; i++) {
            uintArray[i] = byteString.charCodeAt(i);
          }
          return new Blob([arrayBuffer], { type: mimeType });
        };

        const imageBlob = base64ToBlob(capturedImage, "image/jpeg");

        const formData = new FormData();
        formData.append("branchId", String(user.branchId)); // Branch del reloj checador
        formData.append("checkDate", moment().format("YYYY-MM-DD"));
        formData.append("checkTime", moment().format("HH:mm:ss"));
        formData.append("code", values.code);
        formData.append("photo", imageBlob, "captured-image.jpg");
        formData.append("lastName", values.lastName);

        const response = await registerAssistanceCheckByCode(formData);
        console.log("response", response);

        if (response?.type === "error") {
          setloading(false);
          if (response?.errorType === "missingDocuments") {
            const missingList = Array.isArray(response.documentsRequired)
              ? response.documentsRequired
              : (response.documentsRequired as { missing?: MissingDocumentItem[] })?.missing ?? [];
            console.log(
              "📁 [Reloj checador] Documentos inmediatos faltantes:",
              missingList.length ? missingList.map((d) => d.name) : "(ninguno)"
            );
            setMissingDocsModal({ open: true, list: missingList });
            return;
          }
          if (response?.incidents != null || response?.totalIncidents != null) {
            Swal.fire({
              title: "No puede checar",
              text: response?.message || "Tienes incidencias pendientes, revísalas y checa de nuevo.",
              icon: "warning",
              confirmButtonText: "Entendido",
            });
            return;
          }
          Swal.fire({
            title: "No puede checar",
            text: response?.message || "Ocurrió un error al registrar la asistencia.",
            icon: "error",
            confirmButtonText: "Entendido",
          });
          return;
        }

        const partneridMessage =
          response?.assistance?.partner?.id ?? response?.[0]?.partner?.id;
        const messageCode = await fetchInfoCode(partneridMessage);
        setMessageWildcards(messageCode.message);
        notification("success", "Registro guardado exitosamente", "success");
        if (response.message) {
          notification("info", response.message, "info");
        }
        formik.resetForm();
        setloading(false);

        Swal.fire({
          title: "Verificación en Proceso",
          text: "Verificaremos que seas tú, te notificaremos cualquier situación",
          icon: "info",
          showCancelButton: false,
          showConfirmButton: false,
          timer: 4000,
          timerProgressBar: true,
        });

        setTimeout(() => {
          setMessageWildcards("");
        }, 4000);

        setTimeout(() => {
          setShowBranchConfirmation(true);
        }, 4500);
      } catch (error: any) {
        console.error("Hubo un error consulte a soporte", error);
        const status = error?.response?.status;
        const data = error?.response?.data;
        const message = typeof data?.message === "string" ? data.message : null;
        const errorCode = data?.errorCode;

        let displayMessage: string;
        if (status === 404 && errorCode === "CODE_INVALID_OR_EXPIRED") {
          displayMessage =
            "El código no existe o ya venció. Solicita a tu lider otro codigo.";
        } else if (status === 404 && errorCode === "LAST_NAME_MISMATCH") {
          displayMessage = "Apellido incorrecto. Verifique e intente de nuevo.";
        } else if (status === 404 && message) {
          displayMessage = message;
        } else if (status === 404) {
          displayMessage =
            "El código no existe o ya venció, o el apellido es incorrecto. Verifique ambos e intente de nuevo.";
        } else {
          displayMessage = "Datos incorrectos, por favor verifique e intente de nuevo.";
        }

        notification("error", displayMessage, "danger");
        setloading(false);
      }
    },
  });

  // Esto no ando usando pero lo dejo para futuras implementaciones
  const captureImage = () => {
    if (webcamRef.current) {
      const imageSrc = webcamRef.current.getScreenshot();
      setCapturedImage(imageSrc);
      notification("info", "Imagen capturada", "info");
    }
  };
  const fetchConfiguration = async () => {
    const sessionBranch = clockBranchFromSession(user);
    if (sessionBranch) {
      setBranch(sessionBranch);
    }
    try {
      const config = await findConfigurationByKey("assistance");
      setConfiguration(config);
    } catch (error) {
      console.error("Error al obtener la configuración:", error);
    }
  };

  /**
   * Valida el formato del QR y retorna el tipo detectado
   * @param qrData - Datos del QR escaneado
   * @returns 'new' para formato simplificado, 'old' para formato encriptado, 'unknown' para formato no reconocido jairo jairin
   */
  const validateQrFormat = (qrData: QrData): "new" | "old" | "unknown" => {
    if (qrData.p && qrData.t) return "new";
    if (qrData.dataQr && qrData.buildId && qrData.userId) return "old";
    return "unknown";
  };

  /**
   * @param partnerId - ID del partner
   * @param expirationTime - Timestamp de expiración
   * @returns Respuesta del backend
   * @throws Error si el QR expiró o no está autorizado
   */

  const processSimplifiedQr = async (
    partnerId: number,
    expirationTime: number
  ) => {
    const currentTime = Date.now();
    const toleranceTime = 60000; // Agregamos 1 minuto de tolerancia

    // if (currentTime > (expirationTime + toleranceTime)) {
    //   throw new Error("El código QR ha expirado");
    // }

    const response = await validateSimplifiedQr(
      partnerId,
      expirationTime,
      Number(branch?.id ?? user.branchId)
    );

    if (response?.type === "error") {
      return response;
    }

    if (["Not Authorized", "Expired", "Error", "AlreadyUsed"].includes(response.status)) {
      throw new Error(response.message || "Este código QR ya fue utilizado.");
    }

    return response;
  };

  /**
   * @param qrData - Datos del QR encriptado
   * @returns Respuesta de autorización
   * @throws Error si no está autorizado
   */
  const validateEncryptedQr = async (qrData: QrData) => {
    const authorizationResponse = await authorizeAssistance(
      qrData.dataQr,
      qrData.buildId,
      qrData.userId
    );

    if (authorizationResponse.status !== "Authorized") {
      throw new Error(
        "No autorizado: el dispositivo no coincide con el registrado"
      );
    }

    return authorizationResponse;
  };

  /**
   * @param partnerId - ID del partner
   * @returns Objeto con partner y mensaje
   */
  const showPartnerAlert = (message: unknown) => {
    if (!isValidForSweetAlert(message)) return;
    const alert = message as {
      title: string;
      message: string;
      icon: string;
      duration: number;
    };
    Swal.fire({
      title: alert.title,
      text: alert.message,
      icon: alert.icon as any,
      showCancelButton: false,
      showConfirmButton: false,
      timer: alert.duration * 1000,
      timerProgressBar: true,
    });
  };

  const processPartnerMessage = async (partnerId: number, response?: unknown) => {
    const embedded = readClockPartner(response);
    if (embedded) {
      showPartnerAlert(embedded.message);
      return {
        partner: {
          id: embedded.id,
          person: embedded.person || undefined,
        } as Partner,
        message: embedded.message,
      };
    }

    try {
      const partner = await fetchPartner(partnerId);
      const message = await getMessagePartner(partner.id);
      showPartnerAlert(message);
      return { partner, message };
    } catch (error) {
      console.error("El reloj no pudo leer el expediente; el chequeo ya quedó registrado", error);
      return {
        partner: { id: partnerId } as Partner,
        message: null,
      };
    }
  };

  const extractAssistanceStatus = (response: AssistanceResponse) => {
    return response?.assistance?.status || response?.status || "Registrado";
  };

  const extractCheckTime = (response: AssistanceResponse) => {
    return (
      response?.assistance?.checkTime || moment(actualDate).format("HH:mm:ss")
    );
  };

  /**
   * Crea los datos del usuario para mostrar en el modal
   * @param partner - Datos del partner
   * @param status - Status de asistencia
   * @param isNewFormat - Si es formato nuevo o antiguo
   * @param userName - Nombre del usuario (para formato antiguo)
   * @param checkTime - Hora exacta del registro desde el backend
   * @returns Datos del usuario formateados
   */
  const createUserData = (
    partner: Partner,
    status: string,
    isNewFormat: boolean,
    userName?: string,
    checkTime?: string
  ) => {
    if (!partner?.person) {
      return {
        nombre: partner?.name || "Usuario",
        checkAt: checkTime || moment(actualDate).format("HH:mm:ss"),
        status,
      };
    }

    const nombre = isNewFormat
      ? `${partner.person.firstName} ${partner.person.lastName} ${partner.person.secondLastName}`
      : userName || partner.name || "Usuario";

    return {
      nombre,
      checkAt: checkTime || moment(actualDate).format("HH:mm:ss"),
      status,
    };
  };

  /**
   * Maneja el registro exitoso mostrando el modal y notificaciones
   * @param partner - Datos del partner
   * @param isNewFormat - Si es formato nuevo o antiguo
   * @param userName - Nombre del usuario (para formato antiguo)
   * @param checkTime - Hora exacta del registro desde el backend
   */
  const handleSuccessfulRegistration = (
    response: AssistanceResponse,
    partner: Partner,
    isNewFormat: boolean,
    userName?: string,
    checkTime?: string
  ) => {
    const status = extractAssistanceStatus(response);
    const userData = createUserData(
      partner,
      status,
      isNewFormat,
      userName,
      checkTime
    );

    setTempUser(userData);
    setShowRegistrationModal(true);
    triggerUpdate({ branchId: Number(branch?.id ?? user.branchId) });

    if (response.message) {
      notification("info", response.message, "info");
    }

    notification("success", "Registro guardado correctamente", "success");

    setTimeout(() => {
      setShowBranchConfirmation(true);
    }, 3500);
  };

  const safeResetScanner = React.useCallback(
    (registrationSuccessful: boolean) => {
      setScannerEnabled(true);
      setIsValidating(false);
      if (!registrationSuccessful) {
        setTempUser({ nombre: "", checkAt: "", status: "" });
        setShowRegistrationModal(false);
      }
      isProcessingRef.current = false;
    },
    []
  );

  const handleScan = async (detectedCodes: IDetectedBarcode[]) => {
    if (detectedCodes.length === 0) return;

    if (isProcessingRef.current) return;
    if (!scannerEnabled || isValidating) return;

    const rawValue = detectedCodes[0].rawValue;
    if (!rawValue) return;

    const now = Date.now();

    const timeSinceLastScan = now - lastScanTimestampRef.current;
    if (timeSinceLastScan < SCAN_COOLDOWN_MS) {
      return;
    }

    const last = lastProcessedQrRef.current;
    if (
      last &&
      last.rawValue === rawValue &&
      now - last.timestamp < SAME_QR_COOLDOWN_MS
    ) {
      return;
    }

    isProcessingRef.current = true;
    setScannerEnabled(false);
    setIsValidating(true);
    lastScanTimestampRef.current = now;
    setLastScanTime(moment().format("HH:mm:ss"));

    let registrationSuccessful = false;

    try {
      const qrData: QrData = JSON.parse(rawValue);
      const qrFormat = validateQrFormat(qrData);

      if (qrFormat === "unknown") {
        notification("error", "Formato de QR no reconocido", "danger");
        return;
      }

      let response: AssistanceResponse;
      let partner: Partner;

      if (qrFormat === "new") {
        const { p: partnerId, t: expirationTime } = qrData;

        if (!partnerId || !expirationTime) {
          notification("error", "Formato de QR inválido", "danger");
          return;
        }

        response = await processSimplifiedQr(partnerId, expirationTime);

        if (response?.type === "error") {
          try {
            const errorSound = new Audio("/errorsound.mp3");
            errorSound.play().catch(() => {});
          } catch (_) {}

          if (response?.errorType === "missingDocuments") {
            const missingList = Array.isArray(response.documentsRequired)
              ? response.documentsRequired
              : response.documentsRequired?.missing ?? [];
            console.log(
              "📁 [Reloj checador] Documentos inmediatos faltantes:",
              missingList.length ? missingList.map((d) => d.name) : "(ninguno)"
            );
            setMissingDocsModal({
              open: true,
              list: missingList,
              onClose: () => setShowBranchConfirmation(true),
            });
          } else {
            Swal.fire({
              title: "No puede checar",
              text: response?.message || "Ocurrió un error al registrar la asistencia.",
              icon: "error",
              confirmButtonText: "Entendido",
            }).then(() => setShowBranchConfirmation(true));
          }
          return;
        }

        const result = await processPartnerMessage(partnerId, response);
        partner = result.partner;

        const checkTime = extractCheckTime(response);
        handleSuccessfulRegistration(
          response,
          partner,
          true,
          undefined,
          checkTime
        );
        registrationSuccessful = true;
      } else {
        const authorizationResponse = await validateEncryptedQr(qrData);
        const { decryptedDataQr } = authorizationResponse.details;
        const { user, device, ip, municipio, location } = decryptedDataQr;

        const assistanceObject = {
          branchId: user.branchId,
          checkDate: moment(actualDate).format("YYYY-MM-DD"),
          checkTime: moment(actualDate).format("HH:mm:ss"),
          details: {
            partner: user.id,
            deviceId: device.deviceId,
            deviceModel: device.deviceModel,
            deviceName: device.deviceName,
            ip: ip,
            location: municipio,
            coords: JSON.stringify(location),
          },
        };

        response = await registerAssistance(user.id, assistanceObject);

        if (response?.type === "error") {
          Swal.fire({
            title: response?.message,
            icon: "error",
            showCancelButton: false,
            showConfirmButton: false,
            timer: 5 * 1000,
            timerProgressBar: true,
          });
          setTimeout(() => setShowBranchConfirmation(true), 5000);
          return;
        }

        const result = await processPartnerMessage(user.id, response);
        partner = result.partner;

        const checkTime = extractCheckTime(response);
        handleSuccessfulRegistration(
          response,
          partner,
          false,
          user.name,
          checkTime
        );
        registrationSuccessful = true;
      }

      lastProcessedQrRef.current = { rawValue, timestamp: now };
      consecutiveErrorsRef.current = 0; // Reset en éxito
    } catch (error) {
      consecutiveErrorsRef.current += 1;

      if (consecutiveErrorsRef.current >= MAX_CONSECUTIVE_ERRORS) {
        notification(
          "warning",
          "Reactivando cámara tras varios errores...",
          "warning"
        );
        refreshScanner();
        consecutiveErrorsRef.current = 0;
      }

      notification(
        "error",
        error instanceof Error
          ? error.message
          : "Error al procesar el código QR",
        "danger"
      );
    } finally {
      setTimeout(() => safeResetScanner(registrationSuccessful), 3000);
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setActualDate(new Date());
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    fetchConfiguration();
  }, []);

  useEffect(() => {
    console.log(deviceId);
  }, [deviceId]);

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.hidden) {
        setIsScannerPaused(true); // Unmount Scanner → libera MediaStream
      } else {
        setIsScannerPaused(false);
        setCameraPausedByInactivity(false);
        refreshScanner(); // Remount con stream nuevo
      }
    };
    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () =>
      document.removeEventListener("visibilitychange", handleVisibilityChange);
  }, [refreshScanner]);

  // Tras 5s sin escanear: desactivar cámara y mostrar botón para reactivar (evita fetch periódico)
  useEffect(() => {
    if (modeCode || isScannerPaused) return;

    const interval = setInterval(() => {
      const now = Date.now();
      const timeSinceLastScan = now - lastScanTimestampRef.current;
      const timeSinceLastRefresh = now - lastRefreshTimestampRef.current;

      const needsInactivityPause = timeSinceLastScan > INACTIVITY_TIMEOUT_MS;
      const needsHealthRefresh =
        !cameraPausedByInactivity &&
        timeSinceLastRefresh > HEALTH_REFRESH_MS;

      if (needsInactivityPause) {
        setCameraPausedByInactivity(true);
      } else if (needsHealthRefresh) {
        refreshScanner();
      }
    }, HEALTH_CHECK_INTERVAL_MS);

    return () => clearInterval(interval);
  }, [modeCode, isScannerPaused, cameraPausedByInactivity, refreshScanner]);

  if (!configuration)
    return (
      <div className="row d-flex justify-content-between w-50 mx-auto mt-5">
        <div className="alert alert-warning" role="alert">
          <h4 className="alert-heading">¡Atención!</h4>
          <p>
            No se ha establecido una configuración de hora de llegada máxima y
            mínima de entrada.
          </p>
          <hr />
          <p className="mb-0">
            Por favor, completa estos campos desde el menú configuración para
            poder registrar la asistencia de los trabajadores.
          </p>
        </div>
      </div>
    );

  if (!isConnected) {
    return <Loader isLoading={true} />;
  }

  return (
    <div className="w-100 px-4 mt-4 mb-4">
      <div className="row flex-column flex-md-row justify-content-md-between w-100">
        <div
          className={`col-md-${
            Boolean(branch?.typeBanner === "text" && branch?.message) ||
            Boolean(branch?.typeBanner === "file" && branch?.imageUrl)
              ? 12
              : 12
          } ps-2 ${
            !(
              Boolean(branch?.typeBanner === "text" && branch?.message) ||
              Boolean(branch?.typeBanner === "file" && branch?.imageUrl)
            ) && "d-flex justify-content-center"
          }`}
        >
          <div className="bg-white py-3 pt-4 pb-2 rounded-3 shadow mb-4 mb-md-0">
            <div className="mx-auto w-75 text-center mb-3">
              <p
                className={`fs-20px ${
                  scannerEnabled ? "text-success" : "text-secondary"
                }`}
              >
                {scannerEnabled
                  ? `Escanea tu QR ${user?.secondLastName}`
                  : "Escaneado"}
              </p>

              {!modeCode ? (
                <div className="flex-row d-flex justify-content-between mb-3">
                  <div style={{ display: "flex", flexDirection: "row" }}>
                    <select
                      value={deviceId}
                      onChange={(e) => {
                        setDeviceId(e.target.value);

                        setShow(false);
                      }}
                      className="form-select rounded-3 bg-light"
                    >
                      <option value={undefined}>
                        {devices.length === 0
                          ? "Cargando..."
                          : "Selecciona un dispositivo"}
                      </option>
                      {devices.map((device, index) => (
                        <option key={index} value={device.deviceId}>
                          {device.label}
                        </option>
                      ))}
                    </select>
                    <button
                      className="btn btn-info ms-2"
                      onClick={refreshScanner}
                      title="Refrescar cámara (útil si deja de funcionar)"
                    >
                      <i className="fa-solid fa-arrows-rotate"></i>
                    </button>
                  </div>

                  <button
                    className="btn btn-danger p-1 "
                    onClick={() => setModeCode(!modeCode)}
                  >
                    {modeCode ? "Chequeo con QR" : "Chequeo con código"}
                  </button>
                </div>
              ) : (
                <div className="flex-row d-flex justify-content-between mb-3">
                  <div style={{ display: "flex", flexDirection: "row" }}>
                    <button
                      className="btn btn-info ms-2"
                      onClick={toggleFacingMode}
                    >
                      <i className="fa-solid fa-arrows-rotate"></i> Cambiar
                      camara
                    </button>
                  </div>

                  <button
                    className="btn btn-danger p-1 "
                    onClick={() => setModeCode(!modeCode)}
                  >
                    {modeCode ? "Chequeo con QR" : "Chequeo con código"}
                  </button>
                </div>
              )}

              {modeCode ? (
                <div className="w-100 mt-1">
                  <CustomInput
                    formik={formik}
                    field="code"
                    label="Código"
                    placeholder="Ingrese su código aquí..."
                    required={true}
                    sm={8}
                    smLabel={4}
                  />
                  <CustomInput
                    formik={formik}
                    field="lastName"
                    label="Primer apellido"
                    placeholder="Ingrese su primer apellido aqui..."
                    sm={8}
                    smLabel={4}
                    required={true}
                  />

                  <div
                    className="bg-slate-200 border-0 p-2 mb-3 text-center flex rounded-4"
                    style={{  backgroundColor: "#e0f7fa" }}
                  >
                    <div className="card-body d-flex align-items-center justify-content-center gap-2">
                      <i className="fas fa-key fa-2x text-info mb-2" />
                      <p className="mb-0 fw-semibold text-dark">
                        Solicita tu código con el líder
                      </p>
                    </div>
                  </div>


                  <div className="mt-2 position-relative">
                    <Webcam
                      audio={false}
                      ref={webcamRef}
                      screenshotFormat="image/jpeg"
                      className="rounded-3 w-100"
                      videoConstraints={{ facingMode }}
                    />
                    {isCountingDown && (
                      <div className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center bg-dark bg-opacity-75 text-white rounded-3">
                        <div className="text-center">
                          <p className="display-3 fw-bold mb-1">
                            {countdown ?? 0}
                          </p>
                          <small className="text-light">Tomando foto...</small>
                        </div>
                      </div>
                    )}
                  </div>
                  <button
                    className="btn col-12 w-full btn-success mt-1 rounded-3 p-2"
                    onClick={() => formik.handleSubmit()}
                    disabled={loading}
                  >
                    <i className="fas fa-paper-plane"></i> Registrar asistencia
                  </button>

                  {messageWildcards && (
                    <div
                      className="alert justify-content-center text-center alert-primary d-flex mt-2 align-items-center"
                      role="alert"
                    >
                      <i className="fas fa-info-circle me-2"></i>
                      {messageWildcards}
                    </div>
                  )}
                </div>
              ) : (
                <div className="w-100 mt-3 d-flex justify-content-center">
                  {isValidating ? (
                    <div
                      className="position-relative"
                      style={{ width: "600px", height: "532px" }}
                    >
                      <ValidationSkeleton />
                    </div>
                  ) : isScannerPaused ? (
                    <div
                      className="position-relative d-flex align-items-center justify-content-center bg-light rounded-3"
                      style={{ width: "600px", height: "532px" }}
                    >
                      <p className="text-muted mb-0">
                        <i className="fas fa-video-slash me-2"></i>
                        Cámara pausada — vuelve a esta pestaña para reactivar
                      </p>
                    </div>
                  ) : cameraPausedByInactivity ? (
                    <div
                      className="position-relative d-flex flex-column align-items-center justify-content-center bg-light rounded-3"
                      style={{ width: "600px", height: "532px" }}
                    >
                      <p className="text-muted mb-3">
                        <i className="fas fa-video-slash me-2"></i>
                        Cámara desactivada por inactividad
                      </p>
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={activateCamera}
                      >
                        <i className="fas fa-video me-2"></i>
                        Activar cámara
                      </button>
                    </div>
                  ) : (
                    scannerEnabled && (
                      <div
                        className="position-relative"
                        style={{ width: "600px", height: "532px" }}
                      >
                        <Scanner
                          key={refreshKey}
                          onScan={handleScan}
                          scanDelay={SCANNER_SCAN_DELAY_MS}
                          styles={{
                            container: {
                              width: "100%",
                              height: "100%",
                              borderRadius: 10,
                              position: "relative",
                            },
                          }}
                          constraints={{
                            facingMode: "user",
                            width: { ideal: 400 },
                            height: { ideal: 300 },
                          }}
                          onError={(error) => {
                            notification(
                              "warning",
                              "Reactivando cámara...",
                              "warning"
                            );
                            refreshScanner();
                          }}
                        />
                      </div>
                    )
                  )}
                </div>
              )}
            </div>

            <div className="text-center">
              <p className="display-6 mb-2">
                {moment(actualDate).format("dddd, DD MMMM YYYY")}
              </p>
              <small className="text-muted mb-3">
                Versión 1.8.10 | ID: {branch?.id} | Sucursal: {branch?.name}
              </small>
              <p className="display-1 fw-bold">
                {actualDate.toLocaleTimeString()}
              </p>
            </div>

            {/* <div className="mt-4" style={{ minHeight: tempUser.nombre ? "120px" : "0px", transition: "all 0.3s ease" }}>
              {tempUser.nombre && tempUser.checkAt && (
                <div
                  className={`mx-auto w-75 p-3 rounded-4 shadow text-center ${
                    tempUser.status === "Asistencia" ||
                    tempUser.status === "Salida registrada"
                      ? "bg-success text-white"
                      : tempUser.status === "Retardo"
                      ? "bg-danger text-white"
                      : "bg-secondary text-white"
                  }`}
                  style={{ 
                    animation: "fadeInUp 0.5s ease-out",
                    transform: "translateY(0)"
                  }}
                >
                  <div className="d-flex align-items-center justify-content-center mb-2">
                    <i className={`fas fa-${
                      tempUser.status === "Asistencia" ? "check-circle" :
                      tempUser.status === "Retardo" ? "clock" :
                      tempUser.status === "Salida registrada" ? "sign-out-alt" :
                      "user-check"
                    } fa-2x me-3`}></i>
                    <h3 className="display-6 mb-0">{tempUser.nombre}</h3>
                  </div>
                  <p className="h5 mb-2">
                    <strong>Estado:</strong> {tempUser.status}
                  </p>
                  <p className="h6 mb-0">
                    <i className="fas fa-clock me-2"></i>
                    Registro guardado a las: {tempUser.checkAt}
                  </p>
                </div>
              )}
            </div> */}
          </div>
        </div>

        {branch?.typeBanner === "text" && branch?.message && (
          <div className="mt-4 col-md-12 ps-2 d-flex justify-content-center">
            <div className="bg-light p-4 rounded-3 shadow text-center h-100">
              <h1 className="display-5 fw-semibold">Aviso del día</h1>
              <div dangerouslySetInnerHTML={{ __html: branch.message }} />
            </div>
          </div>
        )}

        {branch?.typeBanner === "file" && branch?.imageUrl && (
          <div className="mt-4 col-md-12 ps-2 d-flex justify-content-center">
            <div className="bg-light p-4 rounded-3 shadow text-center h-100">
              <h1 className="display-5 fw-semibold">Aviso del día</h1>
              <img
                src={branch.imageUrl}
                alt="Aviso del día"
                className="img-fluid rounded-3 mt-4"
                style={{ width: "100%", height: "auto" }}
              />
            </div>
          </div>
        )}
      </div>

      {/* Modal de registro de usuario */}
      <UserRegistrationModal
        isVisible={showRegistrationModal}
        userData={tempUser.nombre ? tempUser : null}
        onClose={() => setShowRegistrationModal(false)}
      />

      {/* Modal de documentos faltantes (MUI, solo se cierra con Entendido) */}
      <MissingDocumentsModal
        open={missingDocsModal.open}
        list={missingDocsModal.list}
        onClose={missingDocsModal.onClose}
        onConfirm={() =>
          setMissingDocsModal((prev) => ({ ...prev, open: false }))
        }
      />

      {/* Modal de confirmación de sucursal */}
      {showBranchConfirmation && !isValidating && (
        <BranchConfirmationModal
          branchName={branch?.name || "Desconocida"}
          onConfirm={handleBranchConfirmation}
        />
      )}

      {/* Estilos CSS para animaciones */}
      <style>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  );
};

export default QrScanner;
